import { Input, InputProps, Modal, Spin } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useEffect, useState } from "react";
import { getErrorMessage } from "../utils/errors";
import { useCreateWorkerSSNView } from "../hooks/workerDrawer/useCreateWorkerSsnView";
import { SSN_DEFAULT_LABEL } from "src/containers/accountManagement/agentsOldUX/constants";
import { showErrorToast } from "@src/appV2/lib/Notifications";

interface EditSsnProps extends InputProps {
  eventFn: (value: unknown) => Promise<void>;
  defaultValue: string | undefined;
  isAllowedToViewFullSSN: boolean;
  /**
   * While it is unclear what addOnBefore really means, this
   * code uses it as a partial label.
   */
  addonBefore: string;
  agentId: string;
}

export function EditSSN(props: EditSsnProps) {
  const { eventFn, defaultValue, addonBefore, isAllowedToViewFullSSN, agentId, ...rest } = props;
  const [value, setValue] = useState(defaultValue);
  const [preValue, setPreValue] = useState(defaultValue);
  const [revealSSN, setRevealSSN] = useState(true);
  const { mutateAsync: createWorkerSSNView, isLoading: isSSNLoading } = useCreateWorkerSSNView();
  useEffect(() => {
    setValue(defaultValue);
    setPreValue(defaultValue);
  }, [defaultValue]);

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'e' implicitly has an 'any' type.
  const handleChange = (e) => {
    setValue(e.currentTarget.value);
  };

  const onConfirm = async () => {
    try {
      await eventFn(value);
      setPreValue(value);
    } catch (error) {
      setValue(preValue);
      setRevealSSN(true);
      showErrorToast(getErrorMessage(error));
    }
  };

  const onCancel = () => {
    setValue(preValue);
    setRevealSSN(true);
  };

  const handleEvent = () => {
    if (value !== preValue && !isSSNLoading) {
      Modal.confirm({
        title: `Are you sure, you want to change '${addonBefore}'?`,
        onOk: onConfirm,
        onCancel,
        okText: "Yes",
      });
    }
  };

  const isEditSsnInputDisabled = !isAllowedToViewFullSSN || revealSSN || isSSNLoading;

  const handleOnViewClick = async () => {
    try {
      const response = await createWorkerSSNView({
        workerId: agentId,
        isWorkerAllowedToViewFullSSN: isAllowedToViewFullSSN,
      });
      const ssnResponse = isAllowedToViewFullSSN ? response.ssn : `*****${response.ssn}`;
      setValue(ssnResponse);
      setRevealSSN(false);
      // FIXME: Automatically disabled during ESLint config update
    } catch {
      setValue(preValue);
    }
  };

  const handleOnHideClick = () => {
    setRevealSSN(true);
    setValue(SSN_DEFAULT_LABEL);
  };

  const suffix = isSSNLoading ? (
    <Spin size="small" style={{ color: "rgba(0,0,0,.45)" }} />
  ) : (
    <span />
  );

  return (
    <Input
      data-dd-privacy="mask"
      style={{ width: "55%" }}
      addonBefore={addonBefore}
      suffix={suffix}
      addonAfter={
        revealSSN ? (
          <EyeTwoTone onClick={handleOnViewClick} />
        ) : (
          <EyeInvisibleOutlined onClick={handleOnHideClick} />
        )
      }
      onBlur={handleEvent}
      value={value ?? ""}
      onPressEnter={handleEvent}
      onChange={handleChange}
      disabled={isEditSsnInputDisabled}
      {...rest}
    />
  );
}
